"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _formik = require("formik");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _config = require("../../../../services/config");
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _withGetHotelsAction = _interopRequireDefault(require("../../hocs/withGetHotelsAction"));
var _tp = _interopRequireDefault(require("./img/tp.svg"));
var _trip = _interopRequireDefault(require("./img/trip.svg"));
var _booking = _interopRequireDefault(require("./img/booking.svg"));
var _top = _interopRequireDefault(require("./img/top.svg"));
var _styles = _interopRequireDefault(require("./styles"));
var _excluded = ["getBackground"];
var _getRatingControlInSe, _getRatingControlInSe2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var MIN = 5;
var MAX = 10;
var RATING = R.range(MIN, MAX);
var RATING_PROVIDERS = [{
  icon: _tp.default,
  website: (_getRatingControlInSe = (_getRatingControlInSe2 = (0, _config.getRatingControlInSearchForm)()) === null || _getRatingControlInSe2 === void 0 ? void 0 : _getRatingControlInSe2.tourPravdaWebSite) !== null && _getRatingControlInSe !== void 0 ? _getRatingControlInSe : 'https://www.turpravda.ua'
}, {
  icon: _trip.default,
  website: 'https://www.tripadvisor.com'
}, {
  icon: _booking.default,
  website: 'https://www.booking.com'
}, {
  icon: _top.default,
  website: 'https://www.tophotels.ru'
}];
var transformLastRatingToMaxValue = function transformLastRatingToMaxValue(number) {
  return number === R.last(RATING) ? MAX : number;
};
var isActive = function isActive(number, value) {
  return R.and(transformLastRatingToMaxValue(number) >= value.from, transformLastRatingToMaxValue(number) <= value.to);
};
var removeNumberFromRange = function removeNumberFromRange(number, value) {
  var _from$to = {
      from: R.find(function (ownNumber) {
        return ownNumber > number;
      }, R.range(value.from, value.to)),
      to: R.findLast(function (ownNumber) {
        return ownNumber > number;
      }, R.range(value.from, R.inc(value.to)))
    },
    from = _from$to.from,
    to = _from$to.to;
  return R.mergeAll([from ? {
    from: from
  } : {}, to ? {
    to: to
  } : {}]);
};
var addNumberToRange = function addNumberToRange(number, value) {
  return {
    from: number < value.from ? number : value.from || (number === MAX ? R.dec(number) : number),
    to: number > value.to ? number : value.to || MAX
  };
};
var getExternalProps = function getExternalProps(active) {
  return R.call(R.ifElse(Boolean, function (_ref) {
    var getBackground = _ref.getBackground,
      externalProps = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread({}, externalProps, {
      background: getBackground ? getBackground(active) : undefined
    });
  }, R.always({})), (0, _config.getRatingControlInSearchForm)());
};
var RatingControl = function RatingControl(_ref2) {
  var getHotels = _ref2.getHotels;
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.header
  }, t('RATING_CONTROL_LABEL'), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.icons
  }, R.map(function (_ref3) {
    var icon = _ref3.icon,
      website = _ref3.website;
    return /*#__PURE__*/_react.default.createElement("a", {
      "aria-label": "rating",
      dangerouslySetInnerHTML: {
        __html: icon
      },
      href: website,
      key: website,
      rel: "noopener noreferrer",
      target: "_blank"
    });
  }, RATING_PROVIDERS))), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.checkboxes
  }, /*#__PURE__*/_react.default.createElement(_formik.FastField, {
    name: _fn.QUERY_PARAMS.AVERAGE_RATING,
    render: function render(_ref4) {
      var field = _ref4.field,
        form = _ref4.form;
      return R.map(function (number) {
        var active = isActive(number, field.value);
        return /*#__PURE__*/_react.default.createElement("div", {
          className: _styles.default.checkbox,
          key: number
        }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
          width: _Button.WIDTHS.FLUID,
          size: _Button.SIZES.SMALL,
          theme: active ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
          onClick: function onClick() {
            var nextRating = R.call(active ? removeNumberFromRange : addNumberToRange, transformLastRatingToMaxValue(number), field.value);
            form.setFieldValue(field.name, nextRating);
            getHotels(undefined, nextRating);
          }
        }, getExternalProps(active)), number < 9 ? number : "".concat(number, "+")));
      }, RATING);
    }
  })));
};
var enhancer = R.compose(_withGetHotelsAction.default, _react.memo);
var _default = exports.default = enhancer(RatingControl);